import React from 'react'
import { checkTextTranslation, checkTranslation } from '../../utils/useful'
import { v4 as uuidv4 } from 'uuid';

class AutoIdInput extends React.Component {
    state = {
    }


    componentDidMount() {

        let id = uuidv4()
        // if (!this.props.data) {
        //     this.changeInputValue(id)
        // }
    }


    changeInputValue(value) {

        setTimeout(() => {
            this.props.changeValue(this.props.header.key, value, this.props.extra)

        }, 10);

    }




    focus = () => {
        this.input.focus()
    }
    selectHandler = () => {

    }


    render() {
        let styleInfo = this.props.styleInfo

        return (
            <div className="w-100 h-100 flexc text-start"  >

                <input style={{ color: styleInfo?.textColor, fontWeight: styleInfo?.fontWeight, fontSize: styleInfo?.fontSize }} ref={el => this.input = el} autoFocus={this.props.header.information?.autoFocus} spellCheck={this.props.header.information?.spellCheck} value={this.props.data} onChange={(e) => this.changeInputValue(e.target)} onClick={() => this.selectHandler()} placeholder={checkTranslation(this.props.header.information?.placeholder)} disabled={this.props.header.information?.disabled} className="transpanet-input" />

            </div>
        )
    }
}

export default AutoIdInput;